import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'timestamp',
  standalone: true,
})
export class TimestampPipe implements PipeTransform {
  constructor(private date: DatePipe, private translate: TranslateService) {}

  transform(date: string): string | null {
    return this.formatDate(date);
  }

  private formatDate(valueDate: string): string | null {
    const now = new Date();
    const date = new Date(valueDate);

    const timeDiff = now.getTime() - date.getTime();
    const minutesDiff = Math.floor(timeDiff / (1000 * 60));
    const hoursDiff = Math.floor(timeDiff / (1000 * 60 * 60));
    const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    if (minutesDiff < 1) {
      return this.translate.instant('Shared.Entity.Now').toLowerCase();
    } else if (minutesDiff < 60) {
      if (date.getDay() !== now.getDay()) {
        return this.getDayOfWeek(date);
      } else {
        return minutesDiff + ` ${this.translate.instant('Shared.Entity.Minutes_ago')}`;
      }
    } else if (hoursDiff < 24) {
      if (date.getDay() !== now.getDay()) {
        return this.getDayOfWeek(date);
      } else {
        return hoursDiff + ` ${this.translate.instant('Shared.Entity.Hours_ago')}`;
      }
    } else if (daysDiff < 8) {
      return this.getDayOfWeek(date);
    } else {
      return this.getFormattedDate(date);
    }
  }

  private getDayOfWeek(date: Date): string | null {
    return this.date.transform(date, 'EEEE');
  }

  private getFormattedDate(date: Date): string | null {
    return this.date.transform(date, 'dd.MM.YYYY');
  }
}
